import mockDataService from '../../services/mockDataService';

export default async function (url, options = {}, retries = 3, delay = 1000) {
  // Check if mock data service is enabled and can handle this request
  if (mockDataService.isEnabled && url.includes('/svc/')) {
    try {
      // Generate mock data directly
      const mockData = await mockDataService.generateMockData(url);
      const mockResponseObj = {
        ok: true,
        status: 200,
        json: () => Promise.resolve(mockData),
        text: () => Promise.resolve(JSON.stringify(mockData)),
      };

      return mockResponseObj;
    } catch (error) {
      console.warn(`[MockData] Failed to serve mock data for ${url}:`, error.message);
      // Fall through to real fetch
    }
  }

  // Original fetch logic for non-mock requests
  for (let i = 0; i < retries; i++) {
    try {
      const res = await fetch(url, options);
      if (!res.ok) {
        throw new Error(`Fetch error: ${res.status}`); // eslint-disable-line i18next/no-literal-string
      }
      return res; // If successful, return the response
    } catch (err) {
      console.error(`Attempt ${i + 1} failed: ${err.message}`); // eslint-disable-line i18next/no-literal-string
      if (i < retries - 1) {
        await new Promise((resolve) => setTimeout(resolve, delay)); // Wait before retrying
      } else {
        throw err; // If retries are exhausted, throw the error
      }
    }
  }
}
